export const MessagePrefix = {
  BROADCAST: 'B',
  UNICAST: 'U',
  SYSTEM: 'S',
  JOIN: 'J',
  LEAVE: 'L',
  STAT: 'O',
  ERROR: 'E'
} as const;

export const MESSAGE_PADDING_LENGTH = 14;

export function formatBroadcastMessage(type: string, data: any): string {
  const prefix = MessagePrefix.BROADCAST.padEnd(MESSAGE_PADDING_LENGTH);
  return `${prefix}${type} ${JSON.stringify(data)}`;
}

export function formatStatMessage(data: any): string {
  return `${MessagePrefix.STAT} ${JSON.stringify(data)}`;
}

export function formatErrorMessage(data: any): string {
  return `${MessagePrefix.ERROR} ${JSON.stringify(data)}`;
}

